<template>
  <div class="weixinPay"></div>
</template>

<script>
  import weixinService from "../../services/weixin-service.js";
  import jssdkService from "../../services/jssdk-service.js";
  import httpService from "../../services/http-service.js";

  export default {
    data() {
      return {
        payData: {},
        PayNo: ''
      }
    },
    methods: {
      pay() {
        var _this = this
        wx.error(function (res) {
          alert('错误：' + res);
        });
        wx.ready(function () {
          var ua = navigator.userAgent.toLowerCase();
          if(ua.match(/MicroMessenger/i)=="micromessenger") { // 判断是否在微信浏览器中
            wx.miniProgram.getEnv((res)=>{
                if (res.miniprogram) {
                  //  alert("在小程序里");
                  _this.Minipay()
                } else {
                  //  alert("不在小程序里");
                  _this.doPay();
                }
            })
          } else {
            _this.doPay();
          }
        });
      },
      doPay() {
        var _this = this
        console.log(this.payData);
        wx.chooseWXPay({
          timestamp: _this.payData.Timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: _this.payData.NonceStr, // 支付签名随机串，不长于 32 位
          package: _this.payData.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: _this.payData.SignType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: _this.payData.Signature, // 支付签名
          success: function (res) {
            // 支付成功后的回调函数
            // location.replace('/CheckPayStatus/CheckWeiXinPay?payno=');
            new weixinService().CheckWeiXinPay({ PayNo: _this.PayNo }).then(checkres => {
              // if(res.Data == 1){
              //   alert('支付成功');
              //    _this.$router.push({ path: '/home' })
              // }else if(res.Data == 0){
              //   alert('支付异常，请联系客服')
              //   _this.$router.push({ path: '/home' })
              // }
              if(checkres.Data.IsSuccess == 1){        
                alert('支付成功');
                //  _this.$router.push({ path: '/home' })
                //  window.location.href = res.Data.RedirectUrl
                  const start = Date.parse(new Date("2021/09/15 00:00:00"));
                  const end = Date.parse(new Date("2021/09/22 00:00:00"));
                  const now = Date.parse(new Date());
                  if( now < end && now > start){
                      window.location.href = "https://act.gdtvdv.com/dist/index.html#/oneyuan?actid=11&no=091414435302"
                  } else {
                    window.location.href = checkres.Data.RedirectUrl
                  }
              }else if(checkres.Data.IsSuccess == 0){
                alert('支付异常，请联系客服')
                _this.$router.push({ path: '/home' })
              }
            })
          },
          complete: function (res) {
          },
          cancel: function (res) {
            //alert("支付失败,请联系客服");
            _this.$router.push({ path: '/home' })
          },
          trigger: function (res) {

          },
          fail: function (res) {
            //可能遇到跨号支付
            //alert("支付失败,请联系客服");
            _this.$router.push({ path: '/home' })
          }
        });
      },
      Minipay() {
        wx.miniProgram.redirectTo({ url: '/pages/wxpay/wxpay?timeStamp='+ this.payData.Timestamp+ '&nonceStr=' +this.payData.NonceStr+ '&package='+this.payData.PrepayId+'&signType='+this.payData.SignType+'&paySign='+this.payData.Signature+'&pno='+this.payData.PayNo+'&payFee='+ this.payData.PayFee})
      }
    },
    created() {
      new jssdkService().IntData()
      this.PayNo = new httpService().search('payno')
      
    },
    mounted() {
      new weixinService().getPaymentSgin({ PayNo: this.PayNo }).then(res => {
        this.payData = res.Data
        var ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger") { // 判断是否在微信浏览器中
          wx.miniProgram.getEnv((res)=>{
              if (res.miniprogram) {
                //  alert("在小程序里");
                this.Minipay(res.Data)
              } else {
                //  alert("不在小程序里");
                this.pay()
              }
          })
        } else {
          this.pay()
        }
      }, err => {
        alert('支付异常，请联系客服')
        this.$router.push({ path: '/home' })
      })
    }
  }
</script>

<style scoped>
  .weixinPay {
    font-size: .16rem;
    padding: .1rem;
  }
</style>


// WEBPACK FOOTER //
// src/component/pay/WeiXinPay.vue